import { BrandingStyle } from "@bcm-dev/bcms-vite";
import { LayoutContainer, LeftColumnContainer, RightColumnContainer } from "components/shared";
import React, { useState } from "react";
import { SVGAsset } from "res";
import EDEStatementsMainNavView from "../EDEStatementsMainNavView";
import "./styles.css";
import "./mobile.css";


/**
 * @function EDEStatementsPageHeaderView 
 * @param {React.Component} children - Allows us to inject other components/content. 
 * @returns {React.Component}
 * @example
 * <EDEStatementsPageContentView>
 *  <EDEStatementsPageHeaderView/>
 * </EDEStatementsPageContentView>
 */

export default function EDEStatementsPageHeaderView(props) {
  return (
      <div className="ede-statements-page-header-view">
        <div className="ede-statements-page-header-content flex-container flex-horizontal align-center">
          {props.children}
        </div>
      </div>
  );
}

/**
 * @function EDEStatementsMobilePageHeaderView
 * @returns {React.Component}
 * @example
 * <EDEStatementsPageContentView>
 *  <EDEStatementsMobilePageHeaderView />
 * </EDEStatementsPageContentView>
 */
export function EDEStatementsMobilePageHeaderView(props) {
  const [ showMobileMenu, setShowMenu ] = useState(false);
  const onMenuClick = () => {
    setShowMenu(showMobileMenu ? false : true);
  }

  return (
    <BrandingStyle style={{
            "backgroundColor": "navigation_bar_bg_abi22"
        }} className="some-branding">
      <div className="ede-statements-mobile-page-header-view show-on-mobile">
        <LayoutContainer>
          <LeftColumnContainer dataPoint="Header_Logo" />
          <RightColumnContainer>
              <BrandingStyle
                style={{ "color": "mobile_hamburger_menu_abi22", "fill": "mobile_hamburger_menu_abi22" }}
                className="menu-button-container flex-container flex-vertical align-center justify-right text-right clickable">
                <div className="menu-icon-container set-width">
                  <SVGAsset id="HamburgerMenuIcon" data-point="Mobile_Menu_Icon" onClick={ onMenuClick } />
                </div>
              </BrandingStyle>
          </RightColumnContainer>
        </LayoutContainer>
        { showMobileMenu && <EDEStatementsMainNavView isMobile={ true } /> }
      </div>
    </BrandingStyle>
  );
}